<app-breadcrumb [title]="'Доставчици'" [items]="['Номенклатури']" [active_item]="'Доставчици'"></app-breadcrumb>
<ng-container *ngIf="isLoaded">
  <div style="display: flex; justify-content: end;">
    <button type="button" style="margin-right: 10px;" class="btn btn-primary" *ngIf="canSee()" (click)="onCreation()"><i class="bi bi-check-circle"></i> Добави</button>
    <button type="button" style="margin-right: 10px;" class="btn btn-warning" *ngIf="canSee()" [disabled]="!selectedObject" (click)="onEdit()"><i class="bi bi-exclamation-triangle"></i> Редактирай</button>
    <button type="button" class="btn btn-danger" *ngIf="canSee()" [disabled]="!selectedObject" (click)="onDelete()"><i class="bi bi-exclamation-octagon"></i> Изтриване</button>
  </div>
  <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px; margin-top: 20px;">
    <!-- Search input box -->
    <input type="text" [(ngModel)]="searchQuery" class="form-control" placeholder="Search..." style="flex: 1; margin-right: 10px;">

    <!-- Search button -->
    <button (click)="filterObjects()" class="btn btn-primary">Search</button>
  </div>
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">Име</th>
        <th scope="col">ЕИК</th>
        <th scope="col">Активен</th> 
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let object of filteredObjects" [ngClass]="!isSelected(object)?'':'selected-cell'" (click)="onSelected(object)">
        <td>{{object.serviceProviderName}}</td>
        <td>{{object.serviceProviderEIK}}</td>
        <td>{{object.isActive}}</td> 
      </tr>

    </tbody>
  </table>
</ng-container>
<ng-container *ngIf="!isLoaded">
<div style="text-align: center;">
  <div class="spinner-grow spinner-grow-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</ng-container>
